<!-- DataList -->
<p-table #pdt_custom_list id="customFoldList" [value]="datas" [selection]="datas && datas[activeIndex]" [columns]="columns"
          [selectionMode]="'single'" [columnResizeMode]="'expand'" [reorderableColumns]="true" [rowHover]="true">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="setWidth( col )">
        {{ col.header }}
      </th>
      <ng-container *ngIf="thereIsAction()">
        <th>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-group  let-index="rowIndex" let-columns="columns">
    <tr [pSelectableRow]="group">
      <td *ngFor="let column of columns">
        {{ group[ column.field ] }}
      </td>
      <ng-container *ngIf="thereIsAction()">
        <td>
          <i *ngIf="consultable" title="{{ 'CUSTOM.LIST_COMPONENT.HOVER_DISPLAY_FILE' | translate }}" class="fa fa-eye" aria-hidden="true" (click)="displayFile(index)"></i>
          <i *ngIf="downloadable" title="{{ 'CUSTOM.LIST_COMPONENT.HOVER_DOWNLOAD_FILE' | translate }}" class="fa fa-download" aria-hidden="true" (click)="downloadFile(index); activeIndex=index"></i>
          <i *ngIf="convertibleAsText" title="{{ 'CUSTOM.LIST_COMPONENT.HOVER_DOWNLOAD_FILE_AS_TXT' | translate }}" class="fa fa-file-text" aria-hidden="true" (click)="downloadFileAsTXT(index); activeIndex=index"></i>
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length + 1">
        {{ 'FOLDS.LIST_COMPONENT.EMPTY_MESSAGE' | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [styleClass]="'multi-files-display-modal'" [appendTo]="'body'" [(visible)]="displayConsult"
          [header]="('CUSTOM.LIST_COMPONENT.CONSULT_MODAL_HEADER' | translate)+': '+ displayConsultName"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true"
          [closeOnEscape]="false">
  <object *ngIf="!msBrowsers && pdfToDisplay" [data]="pdfToDisplay + '#view=FitH&zoom=100' | safeObjUrl" type="application/pdf" width="100%" height="100%"></object>
  <div class="grid">
    <p *ngIf="txtToDisplay" class="displayText"> {{txtToDisplay}} </p>

    <div *ngIf="formatNotDisplayable" class="notDisplayable center">
      <p>{{errorMessage}}</p>
      <i class="clickable fa fa-download" aria-hidden="true" (click)="downloadFile(activeIndex)"></i>
    </div>

  </div>

  <i *ngIf="displayConsult && displayLeftArrow" class="clickable arrows rightArrow fa fa-arrow-left"
     aria-hidden="true"
     (click)="displayFile(activeIndex-1)"></i>

  <i *ngIf="displayConsult && displayRightArrow" class="clickable arrows leftArrow fa fa-arrow-right"
     aria-hidden="true"
     (click)="displayFile(activeIndex+1)"></i>
</p-dialog>



